import { app } from '../../../app';
import { Controller } from './contact.controller';

app.component('contact', {
    controller: Controller,
    templateUrl: require('./contact.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/public/contact/contact.component.js